import sirenParse from 'siren-parser';
import { entityStore } from '~/utility/BinSentry-ui-utility';

/**
 * Invalidate timelines for bin owner and its ancestors
 */
export async function invalidateTimelines({ binEntity }) {
  const binOwnerId = binEntity?.getSubEntity('https://api.binsentry.com/rel/bin-owner').href;
  if (binOwnerId) {
    return invalidateTimelineFromOrgId(binOwnerId);
  }
}

export async function invalidateNextOrder({ binEntity }) {
  const nextOrderHref = binEntity?.getSubEntity('https://api.binsentry.com/rel/next-order')?.href;
  if (nextOrderHref) {
    return entityStore.invalidateHref(nextOrderHref);
  }
}

export async function invalidateMostRelevantOrder({ binEntity }) {
  const mostRelevantOrderHref = binEntity?.getSubEntityByRel('https://api.binsentry.com/rel/most-relevant-order')?.href;
  if (mostRelevantOrderHref) {
    return entityStore.invalidateHref(mostRelevantOrderHref);
  }
}

async function invalidateTimelineFromOrgId(orgId) {
  const { entity: org } = await entityStore.fetchWait(orgId);
  const orgEntity = sirenParse(org);
  const timeline = orgEntity.getSubEntityByRel('https://api.binsentry.com/rel/timeline')?.href;
  timeline && entityStore.invalidateHref(timeline);

  // walk tree backwards to purge all timelines
  const parentId = orgEntity.getSubEntity('https://api.binsentry.com/rel/organization-parent')?.href;
  return parentId && invalidateTimelineFromOrgId(parentId);
}
